import { Stars } from '.'

interface Props {
  text: string
  score: number
}
export const Score: React.FC<Props> = ({ text, score }) => {
  return (
    <div className="flex pt-[3px] w-1/2 h-10">
      <div className="w-20">
        <div className="text-sm leading-4 text-center">{text}</div>
        <div className="text-lg leading-4 text-center text-[#005bab]">
          {score.toFixed(1)}
        </div>
      </div>
      <div className="flex relative mt-[5px] w-[125px] h-[26px]">
        <Stars score={score} />
      </div>
    </div>
  )
}
